export default __webpack_public_path__ + "static/media/gaxon.9f281cc5.eot";